"use client";

import { useTranslations } from "next-intl";
import React from "react";
import { getUrl } from "../../helpers/urls/getUrl";
import { useViewportInformation } from "../../hooks/useViewportInformation";
import { useCountry } from "../ApplicationState/hooks";
import { Image } from "../Image";

export const Web2App: React.FC = () => {
    const country = useCountry();
    const t = useTranslations("component.web2App");
    const vp = useViewportInformation();

    // check for vp===null to prevent flickering for server->client hydration
    if (vp === null || vp.breakpointType === "desktop" || country !== "pl") {
        return null;
    }

    return (
        <a href="https://app.adjust.com/1x68spb6" target="_blank">
            <Image
                src={getUrl({
                    type: "assetPath",
                    path: "web2app-20250320.png",
                })}
                alt={t("title")}
                title={t("title")}
            />
        </a>
    );
};
